import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import UpdateUsernameModal from '../components/Modals/UpdateUsernameModal';

const ProfilePage = ({ user }) => {
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [stats, setStats] = useState(null);

  const walletParam = new URLSearchParams(location.search).get('wallet');

  useEffect(() => {
    const fetchProfile = async () => {
      const wallet = walletParam || user?.wallet_address || window.localStorage.getItem('userWallet');

      if (!wallet) {
        setUserData(null);
        return;
      }

      try {
        const res = await axios.get(`http://localhost:5000/api/users/${wallet}`);
        setUserData(res.data);

        const statsRes = await axios.get(`http://localhost:5000/api/stats/${wallet}`);
        setStats(statsRes.data);
      } catch (err) {
        console.error('Error fetching profile or stats:', err);
      }
    };

    fetchProfile();
  }, [walletParam, user]);

  useEffect(() => {
    if (!user && !walletParam) {
      setUserData(null);
    }
  }, [user, walletParam]);

  const handleUsernameUpdate = async (newUsername) => {
    try {
      const res = await axios.put('http://localhost:5000/api/users/update', {
        wallet_address: userData.wallet_address,
        username: newUsername,
      });
      setUserData(res.data);
      setShowModal(false);
    } catch (err) {
      console.error('Error updating username:', err);
    }
  };

  if (!user && !walletParam) {
    return (
      <div style={styles.page}>
        <h2 style={{ fontFamily: 'VT323', color: '#FAFF00' }}>🔌 Please login to view your profile</h2>
      </div>
    );
  }

  if (!userData) return <div style={styles.page}>Loading...</div>;

  return (
    <div style={styles.page}>
      <h1 style={styles.username}>{userData.username || 'Unnamed User'}</h1>
      <div style={styles.addressRow}>
        <a
          href={`https://solscan.io/account/${userData.wallet_address}`}
          target="_blank"
          rel="noopener noreferrer"
          style={styles.addressLink}
        >
          {userData.wallet_address}
        </a>
        <span
          onClick={() => setShowModal(true)}
          style={styles.updateLink}
        >
          (update)
        </span>
      </div>

      {/* Stats Summary */}
      <div style={styles.statsSummary}>
        <p style={styles.text}>Total SOL Backed: <strong>{stats?.totalSolBacked ?? '...'}</strong></p>
        <p style={styles.text}>Total SOL Raised: <strong>{stats?.totalSolRaised ?? '...'}</strong></p>
        <p style={styles.text}>Hit Rate: <strong>{stats ? `${stats.hits} / ${stats.hits + stats.misses}` : '...'}</strong></p>
        <p style={styles.text}>Memes Supported: <strong>{stats?.memesBacked?.length ?? 0}</strong></p>
      </div>

      {/* Grid of Supported Memes */}
      <h2 style={styles.sectionHeader}>🎯 Successful Memes Supported</h2>
      <div style={styles.grid}>
        {(stats?.memesBacked?.length > 0)
          ? stats.memesBacked.map((meme, i) => (
              <div key={i} style={styles.card}>
                <p>{meme.name}</p>
                <p>{meme.ticker}</p>
                <p>Backed: {meme.amount} SOL</p>
                <p>Round: {meme.round}</p>
              </div>
            ))
          : <p style={styles.text}>None yet.</p>}
      </div>

      {/* Grid of Created Memes */}
      <h2 style={styles.sectionHeader}>🧠 Winning Memes Created</h2>
      <div style={styles.grid}>
        {(stats?.memesCreated?.length > 0)
          ? stats.memesCreated.map((meme, i) => (
              <div key={i} style={styles.card}>
                <p>{meme.name}</p>
                <p>{meme.ticker}</p>
                <p>Launched: {meme.launchDate}</p>
                <p style={{ color: '#00FF00' }}>✅ Success</p>
              </div>
            ))
          : <p style={styles.text}>None yet.</p>}
      </div>

      {showModal && (
        <UpdateUsernameModal
          currentUsername={userData.username}
          onSave={handleUsernameUpdate}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: '#2a2a2a',
    color: 'white',
    fontFamily: 'VT323',
    padding: '2rem',
    minHeight: '100vh',
  },
  username: {
    fontSize: '2.5rem',
    marginBottom: '0.5rem',
  },
  addressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '2rem',
  },
  addressLink: {
    color: 'white',
    textDecoration: 'underline',
    fontSize: '1.2rem',
  },
  updateLink: {
    color: '#00FFFF',
    cursor: 'pointer',
    fontSize: '1rem',
  },
  text: {
    fontSize: '1.5rem',
    marginBottom: '0.5rem',
  },
  sectionHeader: {
    fontSize: '1.8rem',
    marginTop: '2rem',
    marginBottom: '1rem',
    color: '#FAFF00',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '1rem',
    marginBottom: '2rem',
  },
  card: {
    backgroundColor: '#1f1f1f',
    padding: '1rem',
    borderRadius: '8px',
    border: '1px solid #444',
  },
  statsSummary: {
    marginBottom: '2rem',
  }
};

export default ProfilePage;
